import { AdjustmentJobsActionTypes } from './constants';

export const INIT_STATE = {
    launchingAdjustmentJob: false,
    gettingAdjustmentJobStatus: false,
    stoppingAdjustmentJob: false,
    restartingAdjustmentJob: false,
    adjustmentJobStatus: null,
    adjustmentJobs: [],
};

type AdjustmentJobsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    launchingAdjustmentJob: boolean,
    gettingAdjustmentJobStatus: boolean,
    stoppingAdjustmentJob: boolean,
    restartingAdjustmentJob: boolean,
    adjustmentJobStatus: string,
    adjustmentJobs: [],
};

const AdjustmentJobs = (state: State = INIT_STATE, action: AdjustmentJobsAction): any => {
    switch (action.type) {
        case AdjustmentJobsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case AdjustmentJobsActionTypes.LAUNCH_ADJUSTMENT_JOB: {
                    return { ...state, launchingAdjustmentJob: false };
                }
                case AdjustmentJobsActionTypes.GET_ADJUSTMENT_JOB_STATUS: {
                    return { ...state, gettingAdjustmentJobStatus: false, adjustmentJobStatus: action.payload.data };
                }
                case AdjustmentJobsActionTypes.STOP_ADJUSTMENT_JOB: {
                    return { ...state, stoppingAdjustmentJob: false };
                }
                case AdjustmentJobsActionTypes.RESTART_ADJUSTMENT_JOB: {
                    return { ...state, restartingAdjustmentJob: false };
                }
                case AdjustmentJobsActionTypes.GET_ALL_ADJUSTMENT_JOBS: {
                    return { ...state, adjustmentJobs: action.payload.data };
                }
                default:
                    return { ...state, launchingAdjustmentJob: false, stoppingAdjustmentJob: false, restartingAdjustmentJob: false, gettingAdjustmentJobStatus: false, adjustmentJobStatus: null, adjustmentJobs: [] };
            }

        case AdjustmentJobsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case AdjustmentJobsActionTypes.LAUNCH_ADJUSTMENT_JOB: {
                    return { ...state, launchingAdjustmentJob: false, error: action.payload.error };
                }
                case AdjustmentJobsActionTypes.GET_ADJUSTMENT_JOB_STATUS: {
                    return { ...state, gettingAdjustmentJobStatus: false, adjustmentJobStatus: null, error: action.payload.error };
                }
                case AdjustmentJobsActionTypes.STOP_ADJUSTMENT_JOB: {
                    return { ...state, stoppingAdjustmentJob: false, error: action.payload.error };
                }
                case AdjustmentJobsActionTypes.RESTART_ADJUSTMENT_JOB: {
                    return { ...state, restartingAdjustmentJob: false, error: action.payload.error };
                }
                case AdjustmentJobsActionTypes.GET_ALL_ADJUSTMENT_JOBS: {
                    return { ...state, adjustmentJobs: [], error: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case AdjustmentJobsActionTypes.LAUNCH_ADJUSTMENT_JOB:
            return { ...state, launchingAdjustmentJob: true };
        case AdjustmentJobsActionTypes.GET_ADJUSTMENT_JOB_STATUS:
            return { ...state, gettingAdjustmentJobStatus: true, adjustmentJobStatus: null };
        case AdjustmentJobsActionTypes.STOP_ADJUSTMENT_JOB:
            return { ...state, stoppingAdjustmentJob: true };
        case AdjustmentJobsActionTypes.RESTART_ADJUSTMENT_JOB:
            return { ...state, restartingAdjustmentJob: true };
        case AdjustmentJobsActionTypes.GET_ALL_ADJUSTMENT_JOBS:
            return { ...state, adjustmentJobs: [], gettingAdjustmentJobStatus: true, adjustmentJobStatus: null };
        default:
            return { ...state };
    }
};

export default AdjustmentJobs;
